import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { Observable, throwError } from 'rxjs';
import { catchError, filter, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthErrorInterceptor implements HttpInterceptor {

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      filter((event) => event instanceof HttpResponse),
      tap((response: HttpResponse<any>) => {
        if (isAuthErrorStatus(response.status) || hasUnauthenticatedErrorCode(response.body)) {
          this.logoutAndRedirect();
        }
      }),
      catchError((err: HttpErrorResponse) => {
        if (isAuthErrorStatus(err.status) || hasUnauthenticatedErrorCode(err.error)) {
          this.logoutAndRedirect();
        }
        return throwError(err);
      })
    );
  }

  async logoutAndRedirect(): Promise<void> {
    await this.authenticationService.logout();
    await this.router.navigateByUrl('/login');
  }
}

function isAuthErrorStatus(status: number): boolean {
  return status === 401;
}

function hasUnauthenticatedErrorCode(body: any): boolean {
  return body && Array.isArray(body.errors) && body.errors
    .filter((error: any) => error.extensions)
    .some((error: any) => error.extensions.code === 'UNAUTHENTICATED');
}
